<template>
  <div id="container">
    <highcharts :options="chartOptions" ref="highcharts" v-show="field != ''"></highcharts>

    <el-select :disabled="startRealtime" filterable collapse-tags auto-complete="true" v-model="field" placeholder="Select">
      <el-option
        v-for="element in listParams"
        :key="element.code"
        :label="element.name"
        :value="element.code">
      </el-option>
    </el-select>
    <div id="noData" v-show="noData && startRealtime">NO DATA FLOW DETECTED</div>
    <el-button id="on" v-show="!startRealtime && field" v-on:click="startRealtime=true">START</el-button>
    <el-button id="off" v-show="startRealtime && field"  v-on:click="startRealtime=false">STOP</el-button>
    <el-button v-show="field" v-on:click="resetGraph">RESET</el-button>
    <el-button v-on:click="showDebug = !showDebug">DEBUG</el-button>

    <div id="debug" v-show="showDebug">
      <span v-for="value in collectedValues"><br/>{{value}}</span>
      <span id="closeDebug" class="el-icon-close" v-on:click="showDebug = !showDebug"></span>
    </div>

  </div>
</template>

<script>
  import Element from 'element-ui';
  import axios from 'axios';
  import HighCharts from 'vue-highcharts'

  export default {
    name: 'Query',
    props: ['listParams'],
    data() {
      return {
        noData: false,
        startRealtime: false,
        field: '',
        collectedValues: [],
        showDebug: false,
        secondsInGraph: 20,
        /* Chart */
        chartOptions: {
          chart: {
            type: 'line',
            zoomType: 'x',
            events: {
              load: () => {
                let app = this;
                setInterval(function () {
                  if(app.startRealtime === true) {
                    app.loadData();
                  }
                }, 1000)
              }
            }
          },
          title: {
            text: 'Realtime graph'
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: 'Time'
            },
          },
          yAxis: {
            title: {
              text: 'Value'
            },
            plotLines: [{
              value: 0,
              width: 1,
              color: "#ccc",
            }],
          },
          legend:{
            enabled: false
          },
          credits: {
            enabled: false,
          },
          series: [{
          }],
        },
      }
    },
    methods:{
      formatDate: function (date) {
        return `${date.getFullYear()}_${("0"+(date.getMonth()+1)).slice(-2)}_${("0"+date.getDate()).slice(-2)}_${("0"+date.getHours()).slice(-2)}_${("0"+date.getMinutes()).slice(-2)}_${("0"+date.getSeconds()).slice(-2)}_00`
      },
      loadData: function () {
        try {
          if(this.$refs.highcharts != null) {
            var series = this.$refs.highcharts.chart.series[0];
            let now = new Date();
            let after = new Date(now.getTime() - 1000)
            var before = new Date(now.getTime() - 2000)
            var app = this;

            axios.post(`https://iiot.dave.eu/api/NOSQLQuery`, {
              device: this.$attrs.deviceId,
              startPoint: this.formatDate(before),
              finishPoint: this.formatDate(after),
              parameter: this.field
            }).then(function (response) {
              if (response.data.length > 0) {
                var shiftFlag =  series.data.length > 20; // How many elements before the graph starts moving to the left
                app.noData = false;
                var value = 0;
                var timesIn = 0;

                response.data.forEach(function (element) {
                    if(series) {
                      app.listParams.forEach(function (param) {
                        if(param.code === app.field)
                          app.collectedValues.push(`${new Date(element.utctime - (before.getTimezoneOffset() * 60000)).toISOString()} - ${param.name} : ${element.data}`)
                      })

                      timesIn++;
                      value += element.data
                    }
                })

                // Do the average
                value = value / timesIn;
                // Scroll the debug window so it stays on the last entry
                document.getElementById("debug").scrollTop = document.getElementById("debug").scrollHeight

                if(timesIn > 0) {
                  // Get the current time and subtract the timezone offset
                  let x = before.getTime() - (before.getTimezoneOffset() * 60000);
                  series.addPoint([x, value, false, shiftFlag])
                  // Move the graph to the left by setting new extremes (the -20000 means it waits 20 seconds before moving [needs to be in sync with the shiftFlag])
                  app.$refs.highcharts.chart.xAxis[0].setExtremes(x - 20000, x, false);
                  app.$refs.highcharts.chart.redraw();
                }
              } else
                app.noData = true;

               }).catch(function (error) {
              console.error(error.response);
            })
          }
        }catch(error){
          console.error(error)
        }
      },
      resetGraph: function () {
        let chart = this.$refs.highcharts.chart;
        chart.series[0].remove();
        chart.addSeries({data: []})
        console.log(chart.series)
      },
      showDebug: function () {

      }
    },
    created: function () {
      /* If the device is small then it doesn't show some elements */
      if(window.innerWidth <= 768) {
        legend = false;
      }
    }
  }
</script>

<style  scoped>

  #container{
    height: 70vh;
    text-align: center;
  }

  #noData{
    padding: 2%;
    width: 15%;
    background-color: #EF4D4D!important;
    border-radius: 10px;
    color: #ffffff;
    font-size: 1.5vw;
    position: absolute;
    left: 5%;
    top: 0;
    animation: pulse 1s ease-out infinite;
  }

  #on{
    border: 1px solid #659b51!important;
    background-color: #80b855!important;
  }
  #off{
    border: 1px solid #9b3737!important;
    background-color: #ef4d4d!important;
    animation: pulseBig 1s ease-out infinite;
  }

  #debug{
    padding-left: 5%;
    text-align: left;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: #ffffff;
    border: 1px var(--primary-color) solid;
    border-radius: 10px;
    height: 150px;
    animation: fadeInUp 1s ease-out;
    overflow-x: scroll;
  }

  #closeDebug{
    position: fixed;
    right: 7%;
    top: 82%;
    cursor: pointer;
  }

  @keyframes pulse {
    0% {transform: scale(0.95, 0.95);}
    70% {transform: scale(1.0, 1.0);}
    100% {transform: scale(0.95, 0.95); }
  }
  @keyframes pulseBig {
    0% {transform: scale(0.95, 0.95);}
    70% {transform: scale(1.1, 1.1);}
    100% {transform: scale(0.95, 0.95); }
  }

  @keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }
    100% {
      opacity: 1;
      transform: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RealtimeGraph.vue